import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-greeting',
  templateUrl: './greeting.component.html',
  styleUrls: ['./greeting.component.scss']
})
export class GreetingComponent implements OnInit {
  welcomeMessage: any;
  @Input() user: any;
  constructor() {
    const hours = new Date().getHours();
    this.welcomeMessage = hours > 12 ? 'Καλησπέρα' : 'Καλημέρα';
  }

  ngOnInit(): void {
  }

}
